<template>
  <div class="flex w-full justify-between">
    <button
      v-if="props.prevStep?.title"
      :class="activeButtonVariant({ theme })"
      @click="$emit('prev')"
    >
      <ArrowRight class="mr-2 rotate-180" />
      <span> {{ props.prevStep?.title }} </span>
      <span v-if="props.prevStep && props.prevStep.showInNavigation">
        : {{ props.prevStep.showInNavigation }}
      </span>
    </button>
    <div v-else></div>
    <div v-if="props.nextStep?.title" :class="navTextVariant({ theme })">
      <span>
        {{ props.nextStep?.title }}
      </span>
      <ArrowRight :class="arrowVariant({ theme })" />
    </div>
    <div v-else></div>
  </div>
</template>

<script lang="ts" setup>
import { cva } from 'class-variance-authority'
import { THEMES } from '../../types/themes'
import ArrowRight from '../atoms/Icons/ArrowRight.vue'

defineEmits(['next', 'prev'])

interface Step {
  title?: string
  showInNavigation?: string
}
const props = withDefaults(
  defineProps<{
    nextStep?: Step
    prevStep?: Step
    theme?: THEMES
  }>(),
  {
    theme: THEMES.DEFAULT,
  },
)

const activeButtonVariant = cva(
  'flex h-[52px] items-center px-5 text-center text-sm uppercase leading-none  lg:px-0 lg:text-lg',
  {
    variants: {
      theme: {
        [THEMES.DEFAULT]: 'text-[#00B4D2] hover:text-[#0088A4] font-[BaileySans]',
        [THEMES.RDK]: 'text-purple hover:text-purple-dark !font-[Avenir LT Std]',
        [THEMES.DJURENS_RATT]: 'text-[#00B4D2] hover:text-[#0088A4] font-[BaileySans]',
      },
    },
    defaultVariants: {
      theme: THEMES.DEFAULT,
    },
  },
)

const arrowVariant = cva('ml-2', {
  variants: {
    theme: {
      [THEMES.DEFAULT]: 'text-[#D9D9D9]',
      [THEMES.RDK]: 'text-grey-700',
      [THEMES.DJURENS_RATT]: 'text-[#D9D9D9]',
    },
  },
  defaultVariants: {
    theme: THEMES.DEFAULT,
  },
})

const navTextVariant = cva(
  'flex h-[52px] items-center px-5 text-center text-sm uppercase leading-none lg:px-0 lg:text-lg',
  {
    variants: {
      theme: {
        [THEMES.DEFAULT]: 'text-[#D9D9D9] font-[BaileySans]',
        [THEMES.RDK]: 'text-grey-700 !font-[Avenir LT Std]',
        [THEMES.DJURENS_RATT]: 'text-[#D9D9D9] font-[BaileySans]',
      },
    },
    defaultVariants: {
      theme: THEMES.DEFAULT,
    },
  },
)
</script>
